export default __webpack_public_path__ + "static/media/Budget-PWA.2dfc3656.png";